import { TableRow as MuiTableRow, type TableRowProps as MuiTableRowProps } from '@mui/material';
import { useContext } from 'react';

import type { WithoutStyleOverrides } from '../../../types/WithoutStyleOverrides';
import { TableRowHoverContext } from './TableRowHoverContext';

type Props = WithoutStyleOverrides<Omit<MuiTableRowProps, 'hover'>>;

export function TableRow(props: Props) {
  const hover = useContext(TableRowHoverContext);

  return <MuiTableRow {...props} hover={hover} />;
}

export type { Props as TableRowProps };
